export const DEFAULT_GOOGLE_SPREADSHEET_SHEET_NAME = "New Sheet";
export const DEFAULT_GOOGLE_SHEET_NAME = "Sheet1";
